import { render, staticRenderFns } from "./newDriver.vue?vue&type=template&id=8fc715ca&scoped=true&"
import script from "./newDriver.vue?vue&type=script&lang=js&"
export * from "./newDriver.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8fc715ca",
  null
  
)

export default component.exports